import {
  LayoutDashboard,
  HardHat,
  CalendarDays,
  FileText,
  FileDiff,
  BookOpen,
  Receipt,
  Users,
  Clock,
  Handshake,
  TrendingUp,
  BarChart3,
  Settings,
  Inbox,
  Globe,
  Sparkles,
} from 'lucide-react';

// Shared BuildBroz Ops navigation config (single source of truth for
// desktop sidebar, mobile drawer, and active-section title resolution).
export const opsNav = [
  { label: 'Dashboard', path: '/ops', icon: LayoutDashboard, end: true },
  { label: 'Projects', path: '/ops/projects', icon: HardHat },
  { label: 'Leads', path: '/ops/leads', icon: Inbox },
  { label: 'Financials', path: '/ops/financials', icon: TrendingUp },
  { label: 'Calendar', path: '/ops/calendar', icon: CalendarDays },
  { label: 'Quotes', path: '/ops/quotes', icon: FileText },
  { label: 'Change Orders', path: '/ops/change-orders', icon: FileDiff },
  { label: 'Price Book', path: '/ops/price-book', icon: BookOpen },
  { label: 'Expenses', path: '/ops/expenses', icon: Receipt },
  { label: 'Employee Pay Tracking', path: '/ops/employee-pay', icon: Clock },
  { label: 'Subcontractor Costs', path: '/ops/subcontractor-costs', icon: Handshake },
  { label: 'Reports', path: '/ops/reports', icon: BarChart3 },
  { label: 'Ops Foreman', path: '/ops/assistant', icon: Sparkles },
  { label: 'Website Admin', path: '/ops/website-admin', icon: Globe },
  { label: 'Settings', path: '/ops/settings', icon: Settings },
];

export const testId = (label) => `ops-nav-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`;
